var map = {
	"./bg.json": [
		"1763",
		"chunk-2d0abc59"
	],
	"./de.json": [
		"c1a2",
		"chunk-2d216595"
	],
	"./en.json": [
		"95f6",
		"chunk-2d0e5da2"
	],
	"./es.json": [
		"e52d",
		"chunk-2d2257d8"
	],
	"./es_MX.json": [
		"bd34",
		"chunk-2d21ab19"
	],
	"./fr.json": [
		"505c",
		"chunk-2d0c739f"
	],
	"./hu.json": [
		"54ca",
		"chunk-2d0c8833"
	],
	"./tr.json": [
		"dd43",
		"chunk-2d2293f5"
	],
	"./uk.json": [
		"f4ca",
		"chunk-2d22ce62"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bc25";
module.exports = webpackAsyncContext;